import axios from "axios";
import settings from "client.settings.json";
import { getLanguage } from "reducers/i18n";

export const getMappings = async (page, tenantId) => {
  const language = getLanguage();
  const mappings = {};

  // const allPages = await axios.get(settings.api + "/api/pages");
  // console.log(allPages.data.pages);

  const response = await axios.get(
    settings.api + "/api/pages" + (tenantId ? `/${tenantId}` : '') + `/${page}`
  );
  const pages = response.data.pages;
  const names = pages.map((p) => p.name);
  names.forEach((name) => {
    mappings[name] = pages.find(
      (p) => p.language === language && p.name === name
    )?.handlebars;
  });
  return mappings;
};
